import React from 'react'
// import ReactGA from 'react-ga'
import Home from './Home'
import Produtos from './Produtos'
import Porque from './Porque'
import Contato from './Contato'
// import PerfectScrollbar from 'react-perfect-scrollbar'
// import 'react-perfect-scrollbar/dist/css/styles.css'

class Main extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      scroll: null
    }

    this.main = React.createRef()
    this.home = React.createRef()
  }
  
  componentDidMount () {
    // ReactGA.initialize('UA-55278565-1')
    // ReactGA.pageview('/home')
  }

  scrollControl = (e) => {
    var x = e.target.scrollTop
    
    this.setState({
      scroll: x
    })
  }

  render() {
    return (
      <main
        onScroll={(e) => { this.scrollControl(e) }}
        ref={this.main}
      >
        <Home ref={this.home}/>
        <Produtos scroll={this.state.scroll}/>
        <Porque/>
        <Contato/>
      </main>
    )
  }
}

export default Main